<template>
  <div>
    <h2>500 Internal Server Error</h2>
    <p>
      Woops! It looks like there is an issue on our end. Check our <a href="https://twitter.com/getdonedone">Twitter page</a>
      for service interruption updates or send us a note with the URL you
      are trying to access to our <a href="https://www.donedone.com/help-center">Support Center</a>.
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ServerError',
})
</script>
